<template>
  <div>
    <!-- Locked indicator for budtenders -->
    <div v-if="isLocked" class="branch-indicator">
      <span class="branch-dot"></span>
      <span class="branch-label">{{ branchName || 'No branch assigned' }}</span>
      <i class="bx bx-lock-alt branch-lock"></i>
    </div>

    <!-- Interactive picker for admins -->
    <b-dropdown v-else variant="light" size="sm" class="branch-indicator-dropdown">
      <template v-slot:button-content>
        <span class="branch-dot"></span>
        <span class="branch-label">{{ branchName || 'Select branch' }}</span>
      </template>
      <b-dropdown-item
        v-for="branch in branches"
        :key="branch.id"
        :active="branch.id == selectedBranchId"
        @click="$emit('select-branch', branch.id)"
      >
        {{ branch.name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    branchName: {
      type: String,
      default: '',
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    branches: {
      type: Array,
      default: () => [],
    },
    selectedBranchId: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/surfaces";
@import "~@/design/tokens/spacing";

.branch-indicator {
  display: inline-flex;
  align-items: center;
  gap: $space-2;
  background: $surface-elevated;
  border-radius: 4px;
  padding: $space-1 $space-3;
  font-size: 0.85rem;
}

.branch-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34c38f;
  flex-shrink: 0;
  margin-right: $space-2;
}

.branch-label {
  font-weight: 600;
}

.branch-lock {
  font-size: 0.9rem;
  opacity: 0.6;
}

.branch-indicator-dropdown ::v-deep .dropdown-toggle {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
}
</style>
